import React, { useId, useState } from "react";
import "./AdminUploadPanel.css";

export function uploadErrorMessage(error) {
  if (error && error.message) {
    return error.message;
  }
  return "The upload didn't go through. Check the file and try again.";
}

export default function AdminUploadPanel({
  title,
  buttonLabel,
  onUpload,
  open,
  onClose,
}) {
  const inputId = useId();
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  if (!open) {
    return null;
  }

  function chooseFile(next) {
    setFile(next || null);
    setStatus("idle");
    setError(null);
  }

  function submit() {
    if (!file || status === "uploading") {
      return;
    }
    setStatus("uploading");
    setError(null);
    onUpload(file)
      .then(() => setStatus("done"))
      .catch((err) => {
        setStatus("error");
        setError(uploadErrorMessage(err));
      });
  }

  return (
    <section className="nfl-upload">
      <div className="nfl-upload-head">
        <span className="nfl-admin-tag nfl-display">Admin</span>
        <h2 className="nfl-upload-title">{title}</h2>
        <button type="button" className="nfl-link-button" onClick={onClose}>
          Close
        </button>
      </div>

      <div className="nfl-upload-body">
        <label
          className={"nfl-upload-drop" + (isDragging ? " is-dragging" : "")}
          htmlFor={inputId}
          onDragOver={(e) => {
            e.preventDefault();
            setIsDragging(true);
          }}
          onDragLeave={() => setIsDragging(false)}
          onDrop={(e) => {
            e.preventDefault();
            setIsDragging(false);
            chooseFile(e.dataTransfer.files[0]);
          }}
        >
          <span className="nfl-upload-filename">
            {file ? file.name : "No file chosen"}
          </span>
          <span className="nfl-upload-hint">Drop a CSV here or choose a file</span>
          <input
            id={inputId}
            type="file"
            accept=".csv,text/csv"
            className="nfl-upload-input"
            onChange={(e) => chooseFile(e.target.files[0])}
          />
        </label>

        <button
          type="button"
          className="nfl-btn nfl-btn-primary"
          onClick={submit}
          disabled={!file || status === "uploading"}
        >
          {status === "uploading" ? "Uploading…" : buttonLabel}
        </button>
      </div>

      {error ? (
        <p className="nfl-inline-error" role="alert">
          {error}
        </p>
      ) : null}

      {status === "done" && file ? (
        <p className="nfl-upload-done" role="status">
          Uploaded. {file.name} is live.
        </p>
      ) : null}
    </section>
  );
}
